import { ApplicationPageAccessResolver } from '../../../modules/application/shared/resolvers/application-page-access/application-page-access-resolver';
import { DirectEntryPageApplicationStateRefreshResolver } from '../../../modules/application/shared/resolvers/direct-entry/direct-entry-page-application-state-refresh-resolver';

/**
 * Resolvers for the pages on Direct Entry.
 */
export const directEntryPageResolvers = {
    ApplicationPageAccessResolver,
    DirectEntryPageApplicationStateRefreshResolver,
} as const;
